import { createApiAction, createClearAction } from 'redux/redux-actions';
import restApis from '../restApis';
import {
  FORGOT_PASSWORD,
  LOGIN,
  REFRESH_TOKEN,
  LOGIN_ORGANIZATION,
  RESET_PASSWORD,
  SIGNUP,
  UPDATE_PROFILE,
  UPLOAD_COVER_IMAGE,
  UPLOAD_LICENSE_IMAGE,
  UPLOAD_LOGO,
  VERIFY_EMAIL,
} from '../constants';

const forgotPasswordApi = restApis('auth/forgot-password').create;
const loginApi = restApis('auth/login').create;
const refreshTokenApi = restApis('auth/refresh-token').create;
const loginOrganizationApi = restApis('auth/login-organization').create;
const resetPasswordApi = restApis('auth/reset-password').create;
const signupApi = restApis('auth/signup').create;
const updateProfileApi = restApis('auth/profile').create;
const uploadCoverImageApi = restApis('auth/upload-cover-image').create;
const uploadLicenseImageApi = restApis('auth/upload-license-image').create;
const uploadLogoApi = restApis('auth/upload-logo').create;
const verifyEmailApi = restApis('auth/verify-email').create;

export const clearAuthToken = createClearAction(LOGIN);
export const login = createApiAction(LOGIN, loginApi);
export const refreshToken = createApiAction(REFRESH_TOKEN, refreshTokenApi);
export const loginOrganization = createApiAction(LOGIN_ORGANIZATION, loginOrganizationApi);
export const resetPassword = createApiAction(RESET_PASSWORD, resetPasswordApi, { title: 'Sent', detail: 'Your password has been changed successfully.' });
export const sendNewPasswordLink = createApiAction(FORGOT_PASSWORD, forgotPasswordApi);
export const signup = createApiAction(SIGNUP, signupApi);
export const updateProfile = createApiAction(UPDATE_PROFILE, updateProfileApi);
export const uploadCoverImage = createApiAction(UPLOAD_COVER_IMAGE, uploadCoverImageApi);
export const uploadLicenseImage =
  createApiAction(UPLOAD_LICENSE_IMAGE, uploadLicenseImageApi);
export const uploadLogo = createApiAction(UPLOAD_LOGO, uploadLogoApi);
export const verifyEmail = createApiAction(VERIFY_EMAIL, verifyEmailApi);

